import { render, staticRenderFns } from "./AutomacaoCanvas.vue?vue&type=template&id=7efa1824"
import script from "./AutomacaoCanvas.vue?vue&type=script&lang=js"
export * from "./AutomacaoCanvas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports